const theme = {
  // PRIMARY COLORS
  PRIMARY_BLACK: '#000000',
  PRIMARY_WHITE: '#FFFFFF',
  SECONDARY: '#FA3F58',
  SECONDARY_10: '#FFECEE',
  SECONDARY_20: '#FED9DE',
  SECONDARY_60: '#FB6579',

  // SHADES OF GREY
  GREY_10: '#F0F2F4',
  GREY_20: '#D2D8DF',
  GREY_30: '#B5BDCA',
  GREY_40: '#97A3B5',
  GREY_50: '#7989A0',
  GREY_60: '#5F6F86',
  GREY_70: '#353E4A',
  GREY_80: '#353E4A',
  GREY_90: '#20252D',

  // ADDITIONAL COLORS
  DARK_BLUE: '#0E3972',
  DARK_PURPLE: '#442176',
  PURPLE: '#A479F9',
  PINK: '#FD509D',
  ORANGE: '#FA7559',
  GREEN: '#27E3A3',
  TALE: '#69EDE9',
  FOG: '#DBEEEF',

  // ACCENT COLORS
  LIME: '#F2FF55',
  MINT: '#71E28C',
  CORAL: '#E7505D',

  // TABLE COLORS
  TABLE_HEADER_BG: '#343236',
  TABLE_FEATURE_BG: '#222023',
  TABLE_EMPTY_BG: '#2A282B',

  // PAGE COLORS
  PAGE_BG_DARK: '#0A0A0B',
  PAGE_BG_PURPLE: '#1A0F2B',
  // Mirrors mobile's FANCHAT_CARD_BG (palette.PURPLE_97) so the light purple the fan sees on
  // the P4P Day landing page is the same tint the app's fan chat cards use.
  PAGE_BG_LIGHT_PURPLE: '#F5EFFF',

  /*
    Mirrors the mobile TeamProfile hero LinearGradient:
    colors [PRIMARY_BLACK #000, DARK_PURPLE #442176] with start y=0.4 / end y=0,
    i.e. DARK_PURPLE at the top, fully black from 40% down. Used by every
    team shout-out surface (CTA share-link screens, in-app shout-out modal).
  */
  TEAM_HERO_GRADIENT: 'linear-gradient(180deg, #442176 0%, #000000 40%, #000000 100%)',

  /*
    Same hero gradient for short surfaces (the shout-out modal): the fade is
    pinned to a fixed height instead of 40% of the box, so a small container
    keeps the thin purple band the full-screen version reads as — a percentage
    stop would flood half the modal with purple.
  */
  TEAM_HERO_GRADIENT_COMPACT: 'linear-gradient(180deg, #442176 0%, #000000 300px, #000000 100%)'
};

export default theme;
